import { useCallback, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { heroSlides } from "@/mocks/gallery";

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);

  const goTo = useCallback((next: number) => {
    setIndex((next + heroSlides.length) % heroSlides.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((current) => (current + 1) % heroSlides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="relative h-[460px] w-full overflow-hidden md:h-[600px]">
      {heroSlides.map((slide, slideIndex) => (
        <div
          key={slide.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            slideIndex === index ? "opacity-100" : "opacity-0"
          }`}
        >
          <img
            src={slide.image}
            alt={slide.title}
            title={`${slide.title} - 美女图片精选`}
            className="h-full w-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/60 via-black/30 to-black/10"></div>
        </div>
      ))}

      <div className="relative z-10 mx-auto flex h-full w-full max-w-7xl flex-col justify-center px-4 md:px-6">
        <div className="max-w-xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-primary-500/90 px-3 py-1 text-xs font-medium text-background-50">
            <i className="ri-camera-lens-line"></i>
            每日精选更新
          </span>
          <h2 className="mt-5 font-heading text-3xl font-semibold leading-tight text-white md:text-5xl">
            {heroSlides[index].title}
          </h2>
          <p className="mt-4 text-sm leading-7 text-white/80 md:text-base">
            {heroSlides[index].subtitle}
          </p>
          <div className="mt-7 flex flex-wrap items-center gap-3">
            <Link
              to={heroSlides[index].link}
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
            >
              查看大图
              <i className="ri-arrow-right-line"></i>
            </Link>
            <Link
              to="/gallery"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-white/40 px-6 py-3 text-sm font-medium text-white transition-colors hover:bg-white/10"
            >
              浏览全部图库
            </Link>
          </div>
        </div>
      </div>

      <button
        type="button"
        onClick={() => goTo(index - 1)}
        aria-label="上一张"
        className="absolute left-3 top-1/2 z-20 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full bg-white/80 text-foreground-900 transition-colors hover:bg-white md:left-6 md:h-11 md:w-11"
      >
        <i className="ri-arrow-left-s-line text-xl"></i>
      </button>
      <button
        type="button"
        onClick={() => goTo(index + 1)}
        aria-label="下一张"
        className="absolute right-3 top-1/2 z-20 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full bg-white/80 text-foreground-900 transition-colors hover:bg-white md:right-6 md:h-11 md:w-11"
      >
        <i className="ri-arrow-right-s-line text-xl"></i>
      </button>

      <div className="absolute bottom-6 left-1/2 z-20 flex -translate-x-1/2 items-center gap-2">
        {heroSlides.map((slide, slideIndex) => (
          <button
            key={slide.id}
            type="button"
            onClick={() => goTo(slideIndex)}
            aria-label={`切换到第 ${slideIndex + 1} 张`}
            className={`h-2 rounded-full transition-all ${
              slideIndex === index ? "w-8 bg-primary-500" : "w-2 bg-white/60"
            }`}
          ></button>
        ))}
      </div>
    </section>
  );
}